import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import {
  checkSubdomain,
  validateClientEmail,
  mainSigup,
  resetSession,
  fetchAllRelatedEvents,
  loginToEvent,
  refreshSessionToken,
} from "Actions";
import { prefilledLogin } from "InitialAction";
import { proceedToDashboard } from "SignupActions";
import { trim } from "BaseComponent";
import {
  isMobile,
  COMMON_FAIL_MESSAGE,
  DEVELOPMENT_TYPE,
  validateSpecialChar,
} from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import LoginErrorBar from "./errorbar";
import LocaleStrings from "Languages";
import ErrorBar from "ReduxErrorBar";

class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      showerror: false,
      alertMessage: "",
      subdomain: "",
    };
  }

  componentWillMount() {
    let { isLoggedIn, user } = this.props;
    // console.log("signup isLoggedIn :- ", isLoggedIn);
    // console.log("signup user :- ", user);

    // if (this.props.isLoggedIn === true) {
    //   this.props.history.push("/dashboard");
    // }
    if (isLoggedIn === true && user.totalAdminEvents > 0) {
      this.props.history.push("/dashboard");
    } else if (isLoggedIn === true && user.totalAdminEvents == 0) {
      setTimeout(() => {
        this.props.history.push("/dashboard/accountsettings/billings");
      }, 1000);
    } else {
      this.props.resetSession();
    }
  }

  renderField(field) {
    var {
      meta: { touched, error },
    } = field;
    var className = `form-group login-element ${
      touched && error ? "has-danger" : ""
    }`;
    return (
      <div className={className}>
        <label>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <input
          className="form-control"
          type={field.type}
          placeholder={field.placeholder}
          {...field.input}
        />
        <div className="text-help">{touched ? error : ""}</div>
      </div>
    );
  }

  renderDomainField(field) {
    var { labelposition, meta } = field;
    var divClassName = `form-group login-element ${
      meta.touched && meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var inputClasses = "position-relative";
    var noteClasses = "text-default text-break";

    return (
      <div className={divClassName}>
        <label>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>

        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
            max={field.max ? field.max : ""}
            style={{ paddingRight: 80 }}
          />

          <div style={{ position: "absolute", right: 10, top: 13 }}>
            .eventify.io
          </div>
        </div>
        <div className="text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>

        <div className={noteClasses}>
          <span>
            {field.note.trim() !== ""
              ? `https://${field.note}.${
                  DEVELOPMENT_TYPE === "koachify" ? "koachify" : "eventify"
                }.io`
              : ""}
          </span>
        </div>
      </div>
    );
  }

  handleChange = (e, val) => {
    let value = val;
    value =
      value.replace(/\s+/g, "") && value.replace(/[^\w]|_/g, "").toLowerCase();

    this.setState({ subdomain: value });
  };

  checkAvailability = (e) => {
    var inputVal = e.target.value;
    let { subdomain } = this.state;
    let { session } = this.props;

    if (subdomain.trim() !== "" && subdomain === inputVal) {
      this.props.checkSubdomain(subdomain, session, (response) => {
        if (response.success === 0) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else if (response.success === 2) {
          this.props.showError(
            `"${subdomain}" ${LocaleStrings.signup_error_subdomain_not_available}`
          );
        } else {
          this.props.showSuccess(
            LocaleStrings.signup_success_subdomain_available
          );
        }
      });
    }
  };

  onFormSubmit(values) {
    let { subdomain } = this.state;
    let { session } = this.props;

    values = { ...values, developmenttype: DEVELOPMENT_TYPE };

    this.setState({ loading: true });
    this.props.validateClientEmail(values, session, (res) => {
      if (res.success === 0) {
        this.setState({
          ...this.state,
          alertMessage: COMMON_FAIL_MESSAGE,
          showerror: true,
          loading: false,
        });
      } else if (res.success === 1 && res.data.length > 0) {
        this.setState({
          ...this.state,
          alertMessage: LocaleStrings.signup_error_email_already_registered,
          showerror: true,
          loading: false,
        });
      } else {
        this.props.checkSubdomain(subdomain, session, (res1) => {
          if (res1.success === 0) {
            this.setState({
              ...this.state,
              alertMessage: COMMON_FAIL_MESSAGE,
              showerror: true,
              loading: false,
            });
          } else if (res1.success === 2) {
            this.setState({
              ...this.state,
              alertMessage: `"${subdomain}" ${LocaleStrings.signup_error_subdomain_not_available}`,
              showerror: true,
              loading: false,
            });
          } else {
            this.props.mainSigup(values, session, (response) => {
              // this.setState({ loading: false });
              if (response.success === 0) {
                this.setState({
                  ...this.state,
                  alertMessage: COMMON_FAIL_MESSAGE,
                  showerror: true,
                  loading: false,
                });
                //setTimeout(() => this.setState({...this.state, showerror: false}), 3000);
              } else if (response.success === 2) {
                this.setState({
                  ...this.state,
                  alertMessage: COMMON_FAIL_MESSAGE,
                  showerror: true,
                  loading: false,
                });
              } else {
                const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                values = {
                  ...values,
                  userid: response.data.userid,
                  clientid: response.data.clientid,
                  groupNumber: response.data.group_number,
                  timezone: tz,
                  isnewclient: true,
                };

                this.props.prefilledLogin(
                  this.props.session,
                  values,
                  ({ data }) => {
                    this.props.refreshSessionToken(
                      this.props.session,
                      { appuserid: data.appuserid },
                      (res) => {
                        this.props.fetchAllRelatedEvents(
                          response.data,
                          this.props.session
                        );
                        this.props.loginToEvent(data);
                        this.props.proceedToDashboard();
                        this.setState({ loading: false });
                      }
                    );
                  }
                );
              }
            });
          }
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal) {
      this.setState({ ...this.state, loading: false });
    }
  }

  render() {
    var { handleSubmit } = this.props;
    var { subdomain } = this.state;

    return (
      <div className="full-height login-background">
        <div className="koachify_signup-container">
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-2 col-lg-2" />
            <div className="col-md-3 col-lg-3 login-content">
              <div className="horizontal-align-right">
                <img
                  src={
                    DEVELOPMENT_TYPE === "koachify"
                      ? "../../style/images/Logo-koachify-white.svg"
                      : "../../style/images/Logo-White.png"
                  }
                />
              </div>
              <div>&nbsp;</div>
              <div className="horizontal-align-right">
                {LocaleStrings.login_page_paragraph}
              </div>
            </div>
            <div className="col-md-5 col-lg-4 login-form-container">
              {this.state.showerror ? (
                <LoginErrorBar alertMessage={this.state.alertMessage} />
              ) : (
                ""
              )}
              <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
                <div className="row">
                  <div className="col-md-12 col-lg-12">&nbsp;</div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12 form-title horizontal-align-center">
                    {LocaleStrings.signup_to_plateform}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">&nbsp;</div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      name="firstname"
                      label={LocaleStrings.signup_form_label_fname}
                      placeholder={LocaleStrings.signup_form_ph_fname}
                      type="text"
                      mandatory="true"
                      component={this.renderField}
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="lastname"
                      label={LocaleStrings.signup_form_label_lname}
                      placeholder={LocaleStrings.signup_form_ph_lname}
                      type="text"
                      mandatory="true"
                      component={this.renderField}
                    />
                  </div>
                  <div className="col-md-12 col-lg-12">
                    <Field
                      name="email"
                      label={LocaleStrings.signup_form_label_email}
                      placeholder={LocaleStrings.signup_form_ph_email}
                      type="email"
                      mandatory="true"
                      component={this.renderField}
                    />

                    <Field
                      name="password"
                      label={LocaleStrings.signup_form_label_password}
                      type="password"
                      placeholder={LocaleStrings.signup_form_ph_password}
                      component={this.renderField}
                    />

                    <Field
                      name="subdomain"
                      label={"Subdomain Name"}
                      placeholder={"ex: techshow2019"}
                      // placeholder={".eventify.io"}
                      note={subdomain}
                      type="text"
                      mandatory="true"
                      component={this.renderDomainField}
                      disabled={false}
                      normalize={trim}
                      disabledCheckAvailability={false}
                      onChange={(e, val) => this.handleChange(e, val)}
                      onBlur={(e) => this.checkAvailability(e)}
                    />

                    <div className="form-group login-element top-buffer">
                      <Button
                        className="btn btn-social-login"
                        loading={this.state.loading}
                        type="submit"
                      >
                        {LocaleStrings.button_signup}
                      </Button>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 col-lg-12">&nbsp;</div>
                  <div className="col-md-12 col-lg-12 horizontal-align-center login-multi-color">
                    {LocaleStrings.already_have_account_text}?{" "}
                    <Link to="/login">{LocaleStrings.login_here}</Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 col-lg-12">&nbsp;</div>
                </div>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
        </div>
        <ErrorBar />
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var firstname = values["firstname"];
  var lastname = values["lastname"];
  var email = values["email"];
  var password = values["password"];
  var subdomain = values["subdomain"];

  if (!firstname || firstname.trim() === "") {
    errors.firstname = LocaleStrings.required;
  }
  if (!lastname || lastname.trim() === "") {
    errors.lastname = LocaleStrings.required;
  }
  if (!email || email.trim === "") {
    errors.email = LocaleStrings.required;
  }
  if (!password || password.trim() === "") {
    errors.password = LocaleStrings.required;
  }
  if (password && password.trim().length < 6) {
    errors.password = LocaleStrings.signup_validate_password_min;
  }
  if (!subdomain || subdomain.trim() === "") {
    errors.subdomain = LocaleStrings.required;
  } else if (validateSpecialChar(subdomain)) {
    errors.subdomain = LocaleStrings.signup_validate_subdomain_specialchar;
  }

  return errors;
}

var mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn,
  user: state.user,
  session: state.session,
});

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  checkSubdomain,
  validateClientEmail,
  mainSigup,
  resetSession,
  prefilledLogin,
  proceedToDashboard,
  fetchAllRelatedEvents,
  loginToEvent,
  refreshSessionToken,
})(
  reduxForm({
    validate,
    form: "SignupForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Signup)
);
